import onelps from '../api';
import { isErrorResponse } from '../api/actions';
import { ENVIRONMENTS } from '../constants/environments';

export const getTranslations = async function(locale, dispatchFn) {
	try {
		if (ENVIRONMENT !== ENVIRONMENTS.DEVELOPMENT) {
			let result = await onelps.actions.translation(locale);
			if (isErrorResponse(result)) {
				// Abort loading as internal server error
				return;
			}
			return onelps.actions.transformTranslation(result);
		} else {
			let translations;
			try {
				translations = require('../../translations.json');
			} catch (error) {
				translations = {};
			}
			return translations;
		}
	} catch (e) {
		dispatchFn({ type: 'SHOW_SERVER_ERROR' });
	}
	return null;
};

export const getLegalLanguage = (onelpsLanguage) => {
	if (onelpsLanguage === 'cs') {
		return 'cz';
	} else {
		return onelpsLanguage;
	}
};